import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Loader2, Handshake } from "lucide-react";

const STAGE_COLORS = {
  "Closed - Win": "bg-green-100 text-green-700",
  "Closed - Discard": "bg-slate-200 text-slate-600",
};

const money = (v) => (v ? new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v) : "—");

export default function DealflowDealsPage() {
  const { token } = useAuth();
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getDealflowDeals(token).then((d) => setDeals(d.items || [])).finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="flex justify-center p-12"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div>;

  return (
    <div className="px-6 space-y-4" data-testid="dealflow-deals-page">
      <p className="text-sm text-muted-foreground">
        Tabla real "Dealflow" de Airtable Observatorio ({deals.length} acuerdos), con importe y probabilidad de cierre — distinta del pipeline B2B interno.
      </p>
      {deals.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="dealflow-deals-empty">Sin acuerdos importados todavía.</p>
      ) : (
        <div className="grid md:grid-cols-2 gap-3">
          {deals.map((d) => (
            <Card key={d.id} data-testid={`dealflow-deal-card-${d.id}`}>
              <CardContent className="p-4 space-y-2">
                <div className="flex items-start justify-between gap-2">
                  <div>
                    <p className="font-medium flex items-center gap-1.5"><Handshake className="w-3.5 h-3.5 text-muted-foreground" />{d.name}</p>
                    <p className="text-xs text-muted-foreground">{d.company_names?.join(", ")}</p>
                  </div>
                  {d.stage && <Badge className={STAGE_COLORS[d.stage] || "bg-blue-100 text-blue-700"}>{d.stage}</Badge>}
                </div>
                <div className="flex flex-wrap gap-3 text-xs text-muted-foreground">
                  {d.amount != null && <span>Importe: {money(d.amount)}</span>}
                  {d.close_probability != null && <span>Prob. cierre: {d.close_probability}%</span>}
                  {d.business && <span>Negocio: {d.business}</span>}
                  {d.start_year && <span>Inicio: {d.start_year}</span>}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
